import React from "react"
import Typography from '@mui/material/Typography';
//import ArrowRightIcon from '@mui/icons-material/ArrowRight';

export const TextLeptinSignal = () => {

return(
<div>
    
<Typography variant="h6" >

Variants are found on genes LEPR, POMC and NTRK2, but these variants are either with heterozygote genotype or based on SNPs which show no relevant record in clinvar for pathogenity.
<br /><br />
Variant rs1187352 on gene NTRK2 is homozygote, but there is evidence in literature found for increased risk regarding obesity.

NTRK2 gene encodes a member of the neurotrophic tyrosine receptor kinase (NTRK) family. This kinase is a membrane-bound receptor that, upon neurotrophin binding, phosphorylates itself and members of the MAPK pathway.<br /><br />
Signalling through this kinase leads to cell differentiation. Mutations in this gene have been associated with obesity and mood disorders. 


 
</Typography>

</div>
)
}